import { render } from "./Casuals.vue?vue&type=template&id=01627c2e&scoped=true"
import script from "./Casuals.vue?vue&type=script&lang=js"
export * from "./Casuals.vue?vue&type=script&lang=js"

import "./Casuals.vue?vue&type=style&index=0&id=01627c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01627c2e"]])

export default __exports__